module.exports = __webpack_public_path__ + "static/seller/img/mr.720483ea.jpg";